import {
  Badge,
  Button,
  Card,
  CardContent,
  CardFooter,
  View,
} from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import { IconButton } from "@/components/ui/icon-button";
import { Info } from "@/components/shared/icons";
import { Divider } from "@/components/shared/divider";
import { copyClipboard } from "@/lib/helpers/copy-clipboard";
import { useSharerModalStore } from "@/store/sharer";

export function ReferralSectionActionCard({
  referralCode,
  loading,
}: {
  referralCode: string;
  loading: boolean;
}) {
  const { setOpen } = useSharerModalStore();

  return (
    <Card
      radius="xl"
      shadow="sm"
      className="native:mx-0 native:-bottom-16 absolute left-0 right-0 z-50 border border-border web:-bottom-12 web:mx-8"
    >
      <CardContent className="p-3">
        <View className="flex flex-row items-center justify-between gap-0">
          <Badge variant="primary" shape="chip" outline={false}>
            <View className="flex flex-row gap-2">
              <Typography variant="label-md" color="brand-primary">
                {loading ? "..." : referralCode}
              </Typography>
              <IconButton
                variant="ghost"
                iconName="copy"
                className="p-0"
                size={"md"}
                color="CTA2"
                disabled={loading}
                onClick={() => copyClipboard(referralCode)}
              />
            </View>
          </Badge>
          <Button
            variant="primary"
            color="CTA"
            size={"md"}
            rounded="full"
            disabled={loading}
            onClick={() => setOpen(true)}
            iconAlignment={"end"}
            iconName="shareFat"
            iconColor="white"
            iconSize={"md"}
          >
            Share
          </Button>
        </View>
      </CardContent>
      <Divider />
      <CardFooter className="flex flex-row items-center gap-1 px-3 pb-3 pt-2">
        <Info size={16} weight="fill" className="text-brand-primary" />
        <Typography variant={"caption-md"} color="foreground-intermediate">
          Earn $15 when your friend completes their first booking
        </Typography>
      </CardFooter>
    </Card>
  );
}
